export const jobSelector = state => state.job.job;
export const jobsSelector = state => state.job.jobs;
export const searchReportJobsSelector = state => state.job.searchReportJobs;
export const jobErrorSelector = state => state.job.error;
export const inquiryValidationErrorsSelector = state =>
  state.job.inquiryValidationErrors;
export const searchReportValidationErrorsSelector = state =>
  state.job.searchReportValidationErrors;
export const quoteValidationErrorsSelector = state =>
  state.job.quoteValidationErrors;
